// extracted by mini-css-extract-plugin
export default {"statistic":"style_statistic__F4Cxi","cryptCard2":"style_cryptCard2__H0JrR","ax1":"style_ax1__QOn7-","up":"style_up__1r1m-"};